import { Component } from '@angular/core';
import { FieldWrapper } from "@ngx-formly/core";

@Component({
    selector: 'app-name-field',
    templateUrl: './name-field.component.html',
    styleUrls: ['./name-field.component.scss']
})
export class NameFieldComponent extends FieldWrapper {

}
